module.exports = __webpack_public_path__ + "17fd08f16ed585ebf23b68655bcddf21.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/audio/notification.mp3
// module id = 3902
// module chunks = 13